import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import cls from 'classnames';

import { urlAPI } from '@/api/urlAPI';
import LogoWhite from '@/assets/logo-white.svg?react';

import styles from './Header.module.scss';

interface HeaderProps {
  href?: string;
  className?: string;
  renderControls?: () => Nullable<ReactElement>;
}

function Header({ href, className, renderControls }: HeaderProps) {
  return (
    <div className={cls(styles.root, className)}>
      <div className={cls(styles.content, 'container')}>
        <Link to={href ?? urlAPI.new('/')}>
          <LogoWhite />
        </Link>

        {renderControls?.()}
      </div>
    </div>
  );
}

export default observer(Header);
